import { authStatusEnum, authTypeEnum } from '@/enums/authEnum'
import { GlobalStore } from '@/store'

/**
 * @description: 判断优惠券否满足认证条件
 */
export function authenticationSure(coupon: { [key: string]: any }) {
  const globalStore = GlobalStore()
  const userAuthInfo = computed(() => globalStore.userAuthInfo)
  // 个人认证标识
  const personAuthFlag = shallowRef<boolean>(
    userAuthInfo.value &&
      (userAuthInfo.value?.auditType === authTypeEnum.PERSON ||
        (userAuthInfo.value.type === authTypeEnum.PERSON &&
          userAuthInfo.value.status !== authStatusEnum.SUCCESS))
  )
  // 企业认证标识
  const companyAuthFlag = shallowRef<boolean>(
    userAuthInfo.value && userAuthInfo.value?.auditType === authTypeEnum.COMPANY
  )
  // 认证标识
  let authentication = 1
  if (personAuthFlag.value) {
    authentication = 2
  } else if (companyAuthFlag.value) {
    authentication = 3
  }
  // 判断是否满足认证条件
  const modelData = JSON.parse(coupon.styleJson)
  return modelData.userList.some((item: any) => {
    return item === authentication
  })
}
